import { render } from "./EFTTermsView.vue?vue&type=template&id=cbdaf382&scoped=true&ts=true"
import script from "./EFTTermsView.vue?vue&type=script&lang=ts"
export * from "./EFTTermsView.vue?vue&type=script&lang=ts"

import "./EFTTermsView.vue?vue&type=style&index=0&id=cbdaf382&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbdaf382"]])

export default __exports__